module.exports = __webpack_public_path__ + "static/img/352.c7923a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200513/352.jpg
// module id = H2Cq
// module chunks = 0